/**
 * Free-text genre → one of the marketing site's 6 demo genre groups.
 * Mirrors the real backend's resolver (/root/ms-studio/src/lib/covers/style-agent.ts,
 * resolveGenre()) — same idea: match keywords, fall back to Literary rather than
 * erroring or guessing. The real app has 12 profiles; this demo has 6, so several
 * real profiles (mystery, sci-fi, children's, horror, nonfiction, poetry) map onto
 * the closest of the 6 shown here — labeled honestly in the result, not hidden.
 */

// [demo genre label, regex, real-backend profile this covers]
const GENRE_KEYWORDS = [
  ['Thriller', /thriller|suspense|crime|mystery|detective|spy|espionage|whodunit|police|noir/i, 'thriller / mystery'],
  ['Romance', /romance|love story|rom[- ]?com|romantic/i, 'romance'],
  ['Memoir', /memoir|biography|autobiograph|personal essay|true story|life story/i, 'memoir'],
  ['Fantasy', /fantasy|sci[- ]?fi|science fiction|dystopia|space opera|magic|dragon|epic|ya|young adult|children/i, 'fantasy / sci-fi'],
  ['Business', /business|self[- ]?help|nonfiction|leadership|finance|entrepreneur|productivity|how[- ]?to/i, 'business / nonfiction'],
  ['Literary', /literary|poetry|poem|horror|thriller[- ]?lit|contemporary|drama|coming[- ]of[- ]age/i, 'literary'],
];

/**
 * @param {string} input free-text genre from the visitor
 * @param {{label:string}[]} genres the local GENRES array (from CoverGalleryPage/CoverStudioPage)
 * @returns {{ index: number, label: string, matched: boolean, backendProfile: string }}
 */
export function resolveGenreToIndex(input, genres) {
  const text = (input || '').trim();
  if (text) {
    for (const [label, re, backendProfile] of GENRE_KEYWORDS) {
      if (re.test(text)) {
        const index = genres.findIndex((g) => g.label === label);
        if (index !== -1) return { index, label, matched: true, backendProfile };
      }
    }
  }
  // Fallback — same principle as the real backend: default to Literary, never error.
  const fallbackIndex = genres.findIndex((g) => g.label === 'Literary');
  return { index: fallbackIndex === -1 ? 0 : fallbackIndex, label: 'Literary', matched: false, backendProfile: 'literary (default)' };
}
